<script setup lang="ts">
import Phone from "~/components/icons/PhoneDark.vue";
import SovendusWidget from "~/components/static/SovendusWidget.vue";

const {locale} = await useLocale("typ", "typ_cq", true);
const emit = defineEmits(["init"]);

defineComponent({
  name: "TypCQ",
});

defineProps({
  name: {
    type: String,
    required: true,
  },
  showSovendus: {
    type: Boolean,
    default: true
  }
});
onMounted(() => emit("init"));
</script>

<template>
  <div class="w-11/12 sm:max-w-7xl mx-auto shadow-lg rounded-3xl bg-white mt-4 mb-10 lg:my-10">
    <div class="mx-auto lg:container text-sm sm:text-base leading-tight text-gray-700">
      <h3 class="pageTitle pt-8 !text-center" v-html="locale?.header.replace('%d', name)" />
      <h4>
        <div
          class="text-center text-lg sm:text-xl mb-4 sm:mb-8 font-semibold px-6"
          v-html="locale?.subheader"
        />
      </h4>
      <h1 class="text-lg sm:text-xl text-center  mt-4 sm:mb-4 bg-yellow py-2 font-semibold" v-html="locale?.title" />
      <div class="max-w-4xl text-lg mx-auto py-4 px-6">
        <div class="flex mb-6 items-center">
          <div class="w-1/5 text-center">
            <Phone class="h-12 mx-auto" />
          </div>
          <p class="w-4/5 pl-4 sm:pl-0 text-sm" v-html="locale?.instructions.first" />
        </div>
        <p class="text-center mt-8" v-html="locale?.thanks" />
        
      </div>
    </div>
    <div class="spacer h-6" />
    <SovendusWidget v-if="showSovendus" />
  </div>

</template>

<style scoped></style>
